(function(){
  var css='.fly-to-cart-bubble{position:fixed;z-index:9999;pointer-events:none;background:#293D30;color:#fff;font-weight:700;font-size:14px;line-height:1;padding:8px 12px;border-radius:999px;box-shadow:0 6px 18px rgba(0,0,0,.25);transform:translate(-50%,-50%);will-change:transform,opacity}';
  var st=document.createElement('style'); st.textContent=css; document.head.appendChild(st);
  // Block the drawer's AUTO-OPEN after Add (renderContents calls open() with no trigger).
  // Cart icon clicks pass the link as trigger, so they still open the drawer.
  function patchOpen(){
    try{
      var C = window.customElements && customElements.get('cart-drawer');
      if(C && C.prototype && !C.prototype.__flyPatched){
        var origOpen = C.prototype.open;
        C.prototype.open = function(triggeredBy){
          if(!triggeredBy) return;
          return origOpen.call(this, triggeredBy);
        };
        C.prototype.__flyPatched = true;
      }
    }catch(e){}
  }
  if(window.customElements && customElements.whenDefined){
    customElements.whenDefined('cart-drawer').then(patchOpen);
  }
  document.addEventListener('DOMContentLoaded', patchOpen);
  function cartLink(){return document.querySelector('#cart-icon-bubble')||document.querySelector('a[href="/cart"]');}
  function fly(qty,fromEl){
    var icon=cartLink(); if(!icon||!fromEl) return;
    var r1=fromEl.getBoundingClientRect(), r2=icon.getBoundingClientRect();
    var x1=r1.left+r1.width/2, y1=r1.top+r1.height/2;
    var x2=r2.left+r2.width/2, y2=r2.top+r2.height/2;
    var b=document.createElement('div');
    b.className='fly-to-cart-bubble'; b.textContent='+'+qty;
    b.style.left=x1+'px'; b.style.top=y1+'px';
    document.body.appendChild(b);
    var midX=(x1+x2)/2, midY=Math.min(y1,y2)-90;
    var anim=b.animate([
      {transform:'translate(-50%,-50%) translate(0px,0px)',opacity:1},
      {transform:'translate(-50%,-50%) translate('+(midX-x1)+'px,'+(midY-y1)+'px)',opacity:1,offset:.5},
      {transform:'translate(-50%,-50%) translate('+(x2-x1)+'px,'+(y2-y1)+'px) scale(.6)',opacity:.2}
    ],{duration:800,easing:'ease-in-out'});
    anim.onfinish=function(){b.remove();};
  }
  function refreshBadge(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var num=document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
      if(num){num.textContent=cart.item_count;}
      var bubble=document.querySelector('#cart-icon-bubble .cart-count-bubble');
      if(bubble){bubble.removeAttribute('hidden');}
    }).catch(function(){});
  }
  function sectionIdOf(el){
    if(!el||!el.closest) return null;
    var sec=el.closest('[id^="shopify-section-"]');
    return sec ? sec.id.replace('shopify-section-','') : null;
  }
  function cartSectionIds(){
    var ids=['cart-drawer','cart-icon-bubble'];
    var secs=document.querySelectorAll('[id^="shopify-section-"]');
    for(var i=0;i<secs.length;i++){
      var el=secs[i];
      var id=el.id.replace('shopify-section-','');
      if(el.querySelector('#cart')||/cart-items|cart-footer/i.test(id)){
        if(ids.indexOf(id)===-1) ids.push(id);
      }
    }
    return ids;
  }
  // Use the theme's OWN renderContents (tested Dawn logic) for drawer + bubble.
  // Falls back to a manual swap if renderContents is not available yet.
  function extractInner(html, tag){
    var m=new RegExp('<'+tag+'[\\s>]').exec(html);
    if(!m) return null;
    var gt=html.indexOf('>', m.index);
    if(gt===-1) return null;
    var e=html.indexOf('</'+tag+'>', gt);
    if(e===-1) return null;
    return html.substring(gt+1, e);
  }
  function swapSections(sections, variantId){
    var swapped={};
    if(!sections) return swapped;
    var drawer=document.querySelector('cart-drawer');
    // Preferred: theme's own renderContents (handles drawer + bubble + is-empty + overlay listener)
    if(drawer && typeof drawer.renderContents === 'function'){
      try{
        drawer.renderContents({id: variantId || '', sections: sections});
        if(sections['cart-drawer']) swapped['cart-drawer']=true;
        if(sections['cart-icon-bubble']) swapped['cart-icon-bubble']=true;
      }catch(e){}
    }
    // Fallback: manual swap for any section renderContents did not cover
    Object.keys(sections).forEach(function(key){
      if(swapped[key]) return;
      var html=sections[key];
      if(key==='cart-drawer'){
        var inner=extractInner(html,'cart-drawer');
        if(drawer&&inner!==null){drawer.innerHTML=inner; swapped[key]=true;}
      } else if(key==='cart-icon-bubble'){
        // Theme renders bubble as .shopify-section inner (icon + "Cart"), not an <a> wrapper
        var m=/<div[^>]*class="shopify-section"[^>]*>/.exec(html);
        var link=document.querySelector('#cart-icon-bubble');
        if(link&&m){
          var gt=html.indexOf('>', m.index);
          var e=html.lastIndexOf('</div>');
          if(gt!==-1&&e>gt){link.innerHTML=html.substring(gt+1, e); swapped[key]=true;}
        }
      } else {
        var el=document.getElementById('shopify-section-'+key);
        if(el){el.innerHTML=html; swapped[key]=true;}
      }
    });
    // Keep the outer drawer's is-empty state in sync with the cart
    return swapped;
  }
  function reopenDrawer(){
    var nd=document.querySelector('cart-drawer');
    if(!nd) return;
    if(typeof nd.open==='function'){try{nd.open(nd);}catch(e){}}
    else{nd.setAttribute('open',''); nd.classList.add('active');}
  }
  var cartBusy=false;
  function cartChange(data){
    if(cartBusy) return;
    cartBusy=true;
    var cartForm=document.getElementById('cart');
    var cartSectionId=sectionIdOf(cartForm);
    var drawerEl=document.querySelector('cart-drawer');
    var drawerOpen=!!drawerEl&&(drawerEl.hasAttribute('open')||drawerEl.classList.contains('active'));
    var ids=cartSectionIds();
    var body=new URLSearchParams();
    if(data.id) body.append('id', data.id);
    if(data.line) body.append('line', data.line);
    body.append('quantity', data.quantity);
    if(ids.length) body.append('sections', ids.join(','));
    fetch('/cart/change.js',{method:'POST',body:body,headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){if(!r.ok) throw new Error('cart change failed'); return r.json();})
      .then(function(res){
        var swapped=swapSections(res.sections, data.id);
        refreshBadge();
        if(cartSectionId && !swapped[cartSectionId]){location.reload(); return;}
        if(drawerOpen && !swapped['cart-drawer']){location.reload(); return;}
        if(drawerOpen && swapped['cart-drawer']){reopenDrawer();}
      })
      .catch(function(){location.reload();})
      .finally(function(){cartBusy=false;});
  }
  function keyFromLineItem(el){
    if(!el||!el.closest) return null;
    var row=el.closest('tr, li, .cart-item, cart-item, [data-line-item]');
    var scope=row||el;
    var q=scope.querySelector('input[data-quantity-line-key]');
    if(q && q.getAttribute('data-quantity-line-key')) return {id:q.getAttribute('data-quantity-line-key')};
    return null;
  }
  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!form||!form.matches||!form.matches('form[action*="/cart/add"]')) return;
    var btn=form.querySelector('[type="submit"]');
    if(btn&&btn.disabled) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var fd=new FormData(form);
    var qty=parseInt(fd.get('quantity')||'1',10)||1;
    var variantId=fd.get('id')||'';
    var ids=cartSectionIds();
    if(ids.length) fd.append('sections', ids.join(','));
    fetch('/cart/add.js',{method:'POST',body:fd,headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){if(!r.ok) throw new Error('add failed'); return r.json();})
      .then(function(res){
        var sw=swapSections(res.sections, variantId);
        if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){fly(qty,btn||form);}
        refreshBadge();
      })
      .catch(function(){form.submit();});
  },true);
  document.addEventListener('click',function(e){
    var t=e.target;
    if(!t||!t.closest) return;
    var btn=t.closest('cart-remove-button, a[href*="/cart/change"], .cart-remove-button');
    if(!btn) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var key=keyFromLineItem(btn);
    if(!key){
      var href=btn.getAttribute('href')||'';
      var m=href.match(/[?&]id=([^&]+)/);
      if(m) key={id:decodeURIComponent(m[1])};
    }
    if(!key){
      var wrap=btn.closest('cart-remove-button');
      var idx=wrap&&wrap.getAttribute('data-index');
      if(idx) key={line:idx};
    }
    if(!key) return;
    cartChange({id:key.id, line:key.line, quantity:0});
  },true);
  document.addEventListener('change',function(e){
    var input=e.target;
    if(!input||!input.getAttribute) return;
    var key=input.getAttribute('data-quantity-line-key');
    if(!key) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    var qty=parseInt(input.value,10);
    if(isNaN(qty)||qty<0) return;
    cartChange({id:key, quantity:qty});
  },true);
})();
